module.exports = __webpack_public_path__ + "960a053803d371e5b8e868773a5ac25d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/jam-pad.png
// module id = 576
// module chunks = 0